"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TodoListIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m3.564,7.613c-.217,0-.435-.083-.601-.249l-1.824-1.823,1.202-1.202,1.223,1.222,2.961-2.961,1.202,1.202-3.562,3.562c-.166.166-.384.249-.601.249Z" }),
        react_1.default.createElement("path", { d: "m3.564,20.34h0c-.226,0-.442-.089-.601-.249l-1.824-1.824,1.202-1.201,1.223,1.223,2.961-2.961,1.202,1.201-3.562,3.562c-.159.16-.375.249-.601.249Z" }),
        react_1.default.createElement("path", { d: "m3.564,13.976c-.217,0-.435-.083-.601-.248l-1.824-1.824,1.202-1.202,1.223,1.222,2.961-2.961,1.202,1.202-3.562,3.562c-.166.166-.384.249-.601.249Z" }),
        react_1.default.createElement("rect", { x: "9.252", y: "4.832", width: "13.608", height: "1.7" }),
        react_1.default.createElement("rect", { x: "9.252", y: "11.15", width: "13.608", height: "1.7" }),
        react_1.default.createElement("rect", { x: "9.252", y: "17.469", width: "13.608", height: "1.699" })));
}
exports.default = TodoListIcon;
